<template>
	<div>
		<el-row class="border">
			<el-col :span="7">
				<div class="radius d1">
					<div v-if="this.month !='' && this.month != null" class="d1title">
						{{this.storeId==''?'':this.storeName[0].title}}{{this.month==''?'':this.month.slice(5,7)}}月累计销售
					</div>
					<div v-else class="d1title">
						{{this.storeId==''?'':this.storeName[0].title}}本月累计销售
					</div>
					<div class="d1content">￥{{total==null?'0':total}}</div>
				</div>
				<div style="margin-top: 10px">
					<div class="flex d2">
						<div class="f"></div>
						<div class="dtitle">今日剪发销售额</div>
						<div class="dcontent">{{haircut==null?'0' : haircut}}</div>
						<span class="dfont">元</span>
					</div>
					<div class="flex d2">
						<div class="f01"></div>
						<div class="dtitle">今日会员销售额</div>
						<div class="dcontent">{{memberTotal==null?'0' : memberTotal}}</div>
						<span class="dfont">元</span>
					</div>
					<div class="flex d2">
						<div class="f02"></div>
						<div class="dtitle">今日权益销售额</div>
						<div class="dcontent">{{quanYi==null?'0' : quanYi}}</div>
						<span class="dfont">元</span>
					</div>
				</div>
			</el-col>
			<el-col :span="17" style="padding-left: 30px">
				<div class="flex">
					<div>
						<el-date-picker @change="getList()" @clear="getList()" value-format="yyyy-MM" size="small"
							v-model="month" style="width: 150px;position: relative;z-index: 100;" type="month"
							placeholder="选择月份">
						</el-date-picker>
					</div>
					<div>
						<el-select @change="getList()" @clear="getList()" v-model="storeId" placeholder="全部门店" clearable
							style="margin-left: 10px;" size="small">
							<el-option-group label="营业门店" class="store">
								<el-option v-for="item in storeList" :key="item.id" :label="item.title"
									:value="item.id">
								</el-option>
							</el-option-group>
							<el-option-group label="结业门店">
								<el-option v-for="item in storeEnd" :key="item.id" :label="item.title" :value="item.id">
								</el-option>
							</el-option-group>
						</el-select>
					</div>
				</div>
				<div id="chart" style="width: 100%;height: 300px"></div>
			</el-col>
		</el-row>
		<el-row style="margin-top: 10px;">
			<el-col class="border" :span="24">
				<div class="d3title" style="flex: 90%">{{this.storeId==''?'':this.storeName[0].title}}拉新留存率</div>
				<div id="chart2" style="width: 100%;height: 300px"></div>
			</el-col>
		</el-row>
		<el-row class="border" style="margin-top: 20px;padding-bottom: 40px">
			<el-col :span="24">
				<div v-if="this.month!=''" class="d3title">
					{{this.month==null?'':this.month}}{{this.storeId==''?'':this.storeName[0].title}}的用户属性
				</div>
				<div v-else class="d3title" style="margin-left: 10px">
					本月{{this.storeId==''?'':this.storeName[0].title}}的用户属性
				</div>
				<div id="pie1" style="width: 100%;height: 350px;"></div>
			</el-col>
			<!-- <el-col :span="12">
				<div v-if="this.month!=''" class="d3title" style="margin-left: 10px">
					{{this.month==null?'':this.month}}{{this.storeId==''?'':this.storeName[0].title}}的开通会员情况
				</div>
				<div v-else class="d3title" style="margin-left: 10px">
					本月{{this.storeId==''?'':this.storeName[0].title}}开通会员情况
				</div>
				<div id="pie2" style="width: 90%;height: 350px;border-left: #d9d9d9 1px solid"></div>
			</el-col> -->
			<el-col :span="24" style="margin-top: 10px;padding-right: 10px">
				<div class="flex">
					<div class="d4title">首次消费</div>
					<div class="d4title">生客</div>
					<div class="d4title">熟客</div>
					<div class="d4title">深度熟客</div>
				</div>
				<div class="flex">
					<div class="d4content">{{first==null?'0':first}}</div>
					<div class="d4content">{{sheng==null?'0':sheng}}</div>
					<div class="d4content">{{shu==null?'0':shu}}</div>
					<div class="d4content">{{shenDu==null?'0':shenDu}}</div>
				</div>
			</el-col>
			<!-- <el-col :span="12" style="margin-top: 10px;padding-left: 10px">
				<div class="flex">
					<div class="d4title">会员</div>
					<div class="d4title">非会员</div>
				</div>
				<div class="flex">
					<div class="d4content">{{member==null?'0':member}}</div>
					<div class="d4content">{{normal==null?'0':normal}}</div>
				</div>
			</el-col> -->
		</el-row>
	</div>
</template>

<script>
	import echarts from "echarts";
	import {
		formatMoney
	} from "../../utils/index.js"
	export default {
		name: "indexNew",
		data: function() {
			return {
				month: '',
				storeId: '',
				storeEnd: [],
				storeList: [],
				allStoreList: [],
				storeName: {},
				total: '',
				haircut: '',
				memberTotal: '',
				member: '',
				normal: '',
				quanYi: '',
				first: '',
				sheng: '',
				shu: '',
				shenDu: '',
				//柱形图数据
				option: {
					tooltip: {
						trigger: 'axis',
						axisPointer: {
							type: 'cross',
							crossStyle: {
								color: '#999'
							}
						}
					},
					grid: [{
						show: false,
						containLabel: false,
						backgroundColor: 'transparent'
					}],
					color: [
						"#69a0ff",
						"#3ce1af",
						"#7285a5",
						"#36d6df",
					],
					toolbox: {
						feature: {
							// dataView: {show: true, readOnly: false},
							magicType: {
								show: true,
								type: ['line', 'bar']
							},
							restore: {
								show: true
							},
							saveAsImage: {
								show: true
							}
						}
					},
					legend: {
						data: ['剪发销售', '会员销售', '权益销售', '客数']
					},
					xAxis: [{
						type: 'category',
						data: ['1月', '2月', '3月', '4月', '5月', '6月'],
						axisPointer: {
							type: 'shadow'
						},
					}],
					yAxis: [{
						type: 'value',
						name: '剪发销售',
						// min: 0,
						// max: 80000,
						// interval: 10000,
						axisLabel: {
							formatter: '{value} 元'
						},
					}, {
						type: 'value',
						name: '客数',
						// min: 0,
						// max: 2000,
						// interval: 200,
						axisLabel: {
							formatter: '{value} 人'
						},
						axisLine: { // y轴线
							show: false
						},
						splitLine: { //y轴网格
							show: false
						},
						// axisTick: { //y轴刻度线
						//   show: false
						// }
					}],
					series: [{
						name: '剪发销售',
						type: 'bar',
						data: [2.0, 4.9, 7.0, 23.2, 25.6, 76.7, 135.6, 162.2, 32.6, 20.0, 6.4, 3.3],
					}, {
						name: '权益销售',
						type: 'bar',
						data: [2.0, 2.2, 3.3, 4.5, 6.3, 10.2, 20.3, 23.4, 23.0, 16.5, 12.0, 6.2],
					}, {
						name: '会员销售',
						type: 'bar',
						data: [2.6, 5.9, 9.0, 26.4, 28.7, 70.7, 175.6, 182.2, 48.7, 18.8, 6.0, 2.3],
					}, {
						name: '客数',
						type: 'line',
						yAxisIndex: 1,
						data: [2.0, 2.2, 3.3, 4.5, 6.3, 10.2, 20.3, 23.4, 23.0, 16.5, 12.0, 6.2],
						// smooth: true
					}]
				},
				//折线图数据
				option2: {
					tooltip: {
						trigger: 'axis'
					},
					color: [
						"#69a0ff",
						// "#000000",
						"#3ee2b0"
					],
					legend: {},
					toolbox: {
						show: true,
						feature: {
							dataZoom: {
								yAxisIndex: 'none'
							},
							dataView: {
								readOnly: false
							},
							magicType: {
								type: ['line', 'bar']
							},
							restore: {},
							saveAsImage: {}
						}
					},
					xAxis: {
						type: 'category',
						boundaryGap: false,
						data: ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun']
					},
					yAxis: {
						type: 'value',
						interval: 10,
						min: 0,
						// max: 50,
						axisLabel: {
							formatter: '{value} %'
						}
					},
					series: [{
						name: '流失率',
						type: 'line',
						data: [10, 11, 13, 11, 12, 12, 9],
					}, {
						name: '拉新率',
						type: 'line',
						data: [10.1, 11.5, 2, 5, 3, 2, 0],
					}]
				},
				//饼图1
				pie1: {
					title: {
						text: '',
						// subtext: '纯属虚构',
						left: 'center'
					},
					color: [
						"#69a0ff",
						"#3ee2b0",
						"#7285a5",
						"#ffc600"
					],
					tooltip: {
						trigger: 'item'
					},
					legend: {
						orient: 'vertical',
						right: 'right',
						top: '160',
						// left:'-100'
					},
					series: [{
						right: '100',
						name: '用户占比',
						type: 'pie',
						radius: '85%',
						data: [{
							value: 1048,
							name: '首次消费'
						}, {
							value: 735,
							name: '生客'
						}, {
							value: 580,
							name: '熟客'
						}, {
							value: 484,
							name: '深度熟客'
						}, ],
						emphasis: {
							itemStyle: {
								shadowBlur: 10,
								shadowOffsetX: 0,
								shadowColor: 'rgba(0, 0, 0, 0.5)'
							}
						}
					}]
				},
				//饼图2
				pie2: {
					title: {
						text: '',
						left: 'center'
					},
					color: [
						"#69a0ff",
						"#3ee2b0"
					],
					tooltip: {
						trigger: 'item'
					},
					legend: {
						orient: 'vertical',
						right: 'right',
						top: '160',
					},
					series: [{
						right: '100',
						name: '会员占比',
						type: 'pie',
						radius: '85%',
						data: [{
							value: 1048,
							name: '会员'
						}, {
							value: 735,
							name: '非会员'
						}, ],
						emphasis: {
							itemStyle: {
								shadowBlur: 10,
								shadowOffsetX: 0,
								shadowColor: 'rgba(0, 0, 0, 0.5)'
							}
						}
					}]
				}
			}
		},
		mounted() {
			const date1 = new Date()
			this.month =
				`${date1.getFullYear()}-${date1.getMonth() + 1 < 10 ? `0${date1.getMonth() + 1}` : date1.getMonth() + 1}`
			this.getList(true)
			this.getStores()
		},
		methods: {
			chart() {
				let myChart = this.$echarts.init(document.getElementById('chart'))
				myChart.setOption(this.option);
				let chart2 = this.$echarts.init(document.getElementById("chart2"))
				chart2.setOption(this.option2);
				let pie1 = this.$echarts.init(document.getElementById("pie1"))
				pie1.setOption(this.pie1);
				let pie2 = this.$echarts.init(document.getElementById("pie2"))
				pie2.setOption(this.pie2);
				//缩放时调整图像大小
				window.addEventListener("resize", () => {
					myChart.resize();
					chart2.resize();
					pie1.resize();
					pie2.resize();
				})
			},
			getList(type) {
				if (this.storeId != null) {
					this.storeName = this.allStoreList.filter(item => {
						if (item.id == this.storeId) {
							return item.title
						}
					})
				}
				if (this.month == null) {
					this.month = ''
				}
				const a = "?month=" + this.month + "&storeId=" + this.storeId
				this.$http.get("dbarrel/listIndex" + a).then(res => {
					this.start()
					const s = res.body.data;
					this.sortarr(s)
					s.forEach(item => {
						//柱形图数据
						this.option.series[0].data.push(item.hairCut)
						this.option.series[1].data.push(item.quanYiTotal)
						this.option.series[2].data.push(item.memberTotal)
						this.option.series[3].data.push(item.customer)
						this.option.xAxis[0].data.push(item.month)
						//折线图数据
						this.option2.series[0].data.push(item.loseRate / 100)
						this.option2.series[1].data.push(item.pullRate / 100)
						this.option2.xAxis.data.push(item.month)
					})
					//月份总计
					const maxindex = s.length - 1
					this.total = s[maxindex].total;
					this.total = formatMoney(this.total)
					console.log(this.total)
					//用户属性饼图数据
					const p1 = this.pie1.series[0]
					const p2 = this.pie2.series[0]
					this.first = 0
					this.sheng = 0
					this.shu = 0
					this.shenDu = 0
					this.member = 0
					this.normal = 0
					console.log(this.month)
					if (this.month == '' || this.month == null) {
						// console.log("总和")
						s.forEach(item => {
							this.first += item.first
							this.sheng += item.sheng
							this.shu += item.shu
							this.shenDu += item.shendu
							this.member += item.member
							this.normal += item.normal
						})
					} else {
						// console.log("单月")
						this.first = s[maxindex].first
						this.sheng = s[maxindex].sheng
						this.shu = s[maxindex].shu
						this.shenDu = s[maxindex].shendu
						this.member = s[maxindex].member
						this.normal = s[maxindex].normal
					}
					p1.data[0].value = this.first
					p1.data[1].value = this.sheng
					p1.data[2].value = this.shu
					p1.data[3].value = this.shenDu
					p2.data[0].value = this.member
					p2.data[1].value = this.normal
					this.changeTip(0)
					if (this.storeId !== '') {
						this.changeTip(1)
					} else {
						this.changeTip(0)
					}
				})
				this.$http.get("dbarrel/indexDay" + a).then(res => {
					const s = res.body.data;
					this.haircut = s.dayHairCut;
					this.memberTotal = s.dayMember;
					this.quanYi = s.dayQuanYi;
				})
				this.$nextTick(() => {
					this.chart()
				})
			},
			//改变刻度
			changeTip(id) {
				// if (id === 0) { //全部
				// // 	this.option.yAxis[0].max = 400000 //业绩上限
				// // 	this.option.yAxis[0].interval = 50000 //业绩间隔
				// // 	this.option.yAxis[1].max = 10000 //客数上限
				// // 	this.option.yAxis[1].interval = 1000 //客数间隔

				// // } else { //单个门店
				// // 	this.option.yAxis[0].max = 80000
				// // 	this.option.yAxis[0].interval = 10000 //业绩间隔
				// // 	this.option.yAxis[1].max = 2000 //客数上限
				// // 	this.option.yAxis[1].interval = 200 //客数间隔
				// }
				this.$nextTick(() => {
					this.chart()
				})
			},
			getStores() {
				this.$http.get("store/list").then(res => {
					res.body.data.forEach(ele => {
						this.allStoreList.push(ele)
						if (ele.businessType === 1) {
							this.storeEnd.push(ele) //结业门店
						} else {
							this.storeList.push(ele) //营业门店
						}
					})
				})
				// console.log(this.storeList)
			},
			//初始化数据
			start() {
				this.option.series.forEach(i => {
					i.data = []
				})
				this.option2.series.forEach(i => {
					i.data = []
				})
				this.option.xAxis[0].data = []
				this.option2.xAxis.data = []
			},
			//按日期排序
			sortarr(arr) {
				arr.sort((a, b) => {
					return new Date(a.month) - new Date(b.month);
				});
				return arr;
			}
		}
	}
</script>

<style lang="less" scoped>
	.blue {
		width: 6px;
		height: 25px;
		background-color: #00a0e9;
	}

	.flex {
		display: flex;
	}

	.border {
		box-shadow: rgba(13, 13, 13, 0.53) 2px 1px 5px;
		padding: 10px 10px 0px 15px;
	}

	.radius {
		/*border: 2px solid;*/
		border-radius: 8px;
	}

	.d1 {
		color: #ffffff;
		background: linear-gradient(to right, #69a0ff, #3ee2b0);
		font-size: 18px;
		padding: 10px 10px 10px 20px;

		.d1title {
			color: #ffffff;
		}

		.d1content {
			color: #ffffff;
			font-size: 38px;
			font-weight: 800;
			font-family: SourceHanSansCN-Bold;
		}
	}

	.dfont {
		color: #bfbfbf;
		margin-left: 10px;
		margin-top: 5px;
		font-size: 20px;
	}

	.d2 {
		margin-top: 5px;
		line-height: 40px;
		border-bottom: #ecebeb 1px solid;

		.f {
			width: 7px;
			height: 40px;
			background-color: #69a0ff;
		}

		.f01 {
			width: 7px;
			height: 40px;
			background-color: #6fe9c3;
		}

		.f02 {
			width: 7px;
			height: 40px;
			background-color: #7285a5;
		}
	}

	.d3title {
		font-weight: 800;
		font-size: 18px;
	}

	.d4title {
		font-weight: 800;
		font-size: 16px;
		flex: 1;
		background-color: #efefef;
		text-align: center;
	}

	.d4content {
		flex: 1;
		text-align: center;
	}

	.dtitle {
		margin-left: 5px;
		margin-top: 3px;
		line-height: 40px;
		font-size: 22px;
		flex: 10%;
		color: #a7a7a7;
	}

	.dcontent {
		margin-top: 3px;
		line-height: 40px;
		float: right;
		font-size: 24px;
	}
</style>